import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import {
  File as IFile,
  FindManyFiles,
  FindOne,
  PaginateResult,
  UpdateFile,
} from '@univacity/shared/types';
import { Observable } from 'rxjs';
import { Configuration } from '../config/configuration';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private baseUrl: string;

  constructor(private http: HttpClient, private config: Configuration) {
    this.baseUrl = this.config.apiMediaUrl + '/file';
  }

  find(query: FindManyFiles = {}): Observable<PaginateResult<IFile>> {
    const params = new HttpParams({ fromObject: query as Params });
    return this.http.get<PaginateResult<IFile>>(this.baseUrl, { params });
  }

  findOne(file: string, query: FindOne = {}) {
    const slash = file.startsWith('/') ? '' : '/';
    const params = new HttpParams({ fromObject: query as Params });
    return this.http.get<IFile>(`${this.baseUrl}${slash}${file}`, { params });
  }

  update(id: string, file: UpdateFile) {
    const slash = id.startsWith('/') ? '' : '/';
    return this.http.patch<IFile>(`${this.baseUrl}${slash}${id}`, file);
  }

  delete(id: string) {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  updateMeta(files: IFile[]) {
    return this.http.patch<IFile[]>(this.baseUrl, { files });
  }
}
